export const CATEGORIES = [
  { id: 'jackets', title: 'Jackets' },
  { id: 'pants', title: 'Pants' },
];

export const PRODUCTS = [
  { id: 'p01', name: 'Heavyweight Oversized Tee Black', category: 'tshirts', price: 420, oldPrice: 520, sizes: ['S', 'M', 'L', 'XL', 'XXL'], tag: 'new' },
  { id: 'p06', name: 'Cargo Pant Olive', category: 'pants', price: 850, sizes: ['30', '32', '34', '36', '38'], tag: 'best' },
];

export const REVIEWS = [
  {
    id: 'starter-review-karim',
    name: 'Karim A.',
    city: 'Cairo',
    text: 'The oversized tee is real heavyweight cotton, not the thin stuff. Fit is exactly like the photos.',
  },
  {
    id: 'starter-review-mohamed',
    name: 'Mohamed S.',
    city: 'Alexandria',
    text: 'Ordered the cargo pant in 32 and it fit first try. The stitching held up after a lot of washes.',
  },
  {
    id: 'starter-review-youssef',
    name: 'Youssef H.',
    city: 'Tanta',
    text: 'Size chart was accurate and the exchange took two days.',
  },
];

export const formatPrice = (value) => `${Number(value ?? 0).toLocaleString('en-US')} EGP`;
